
export default {
  name: 'NotSupportedBrowser'
}
